import React from "react";
import { useTranslation } from "react-i18next";
import { styled } from "styled-components";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { fadeInTitleTopVariant, fadeInLeftVariant } from "../utils/variants";
import { BackgroundElementServices } from "../components/GlobalStyle";
// import NeiltalkHome from "../assets/neiltalk-home.webp";
// import NeiltalkServices from "../assets/neiltalk-services.webp";
// import NeiltalkContact from "../assets/neiltalk-contact.webp";
// import NotAvailable from "../assets/not-available.webp";

const Works = () => {
  const { t } = useTranslation();
  const projects = t("works.projects", { returnObjects: true });

  const getArticleStyle = (index) => {
    if (index === 0) return ArticleSecond;
    if (index === 1) return ArticleThird;
    if (index === 2) return ArticleFour;
    if (index === 3) return ArticleFifth;
    return ArticleSecond; // fallback
  };

  return (
    <MainContainer>
      <motion.h1
        variants={fadeInTitleTopVariant}
        initial="hidden"
        whileInView="visible"
      >
        {t("works.work_title")}
      </motion.h1>
      <Container>
        <BackgroundElementServices className="red-1" />
        <BackgroundElementServices className="blue-1" />
        <BackgroundElementServices className="red-2" />
        <BackgroundElementServices className="blue-2" />

        <SectionFirst>
          <ArticleFirst
            as={motion.article}
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1 }}
          >
            {t("works.subtitle")}
          </ArticleFirst>
        </SectionFirst>

        <SectionSecond>
          {projects.map((project, index) => {
            const ArticleComponent = getArticleStyle(index);
            return (
              <ArticleComponent key={project.id}>
                <Link to={`/work-details/${project.slug}`}>
                  <MotionPicture
                    // className="picture"
                    //as={Picture}
                    initial={{ opacity: 0, scale: 0.5 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 1, delay: 0.5 + index * 0.3 }}
                  >
                    <Img
                      src={project.images[0].src}
                      alt={project.images[0].alt}
                    />
                  </MotionPicture>
                </Link>
                <DivText
                  as={motion.div}
                  variants={fadeInLeftVariant}
                  initial="hidden"
                  whileInView="visible"
                  transition={{
                    type: "tween",
                    duration: 1,
                    delay: 0.2 + index * 0.3,
                  }}
                >
                  <Title>{project.title}</Title>
                  <Text>{project.shortText}</Text>
                  <Category>{t("works.category")}</Category>
                </DivText>
              </ArticleComponent>
            );
          })}
        </SectionSecond>
      </Container>
    </MainContainer>
  );
};

export default Works;

const MainContainer = styled.main`
  padding: 6rem 0 5rem 0;
`;

const Container = styled.div`
  display: grid;
  width: 80%;
  margin: auto;
  grid-template-columns: 250px 1fr;
  // gap: 10rem;
  align-items: center;
  padding-top: 3rem;
  justify-items: end;

  @media (max-width: 1024px) {
    gap: 5rem;
  }

  @media (min-width: 480px) and (max-width: 576px) {
    max-width: 80%;
    margin: auto;
    display: flex;
    flex-direction: column;
  }

  @media (min-width: 575px) and (max-width: 768px) {
    max-width: 90%;
    margin: auto;
    display: flex;
    flex-direction: column;
  }

  @media (min-width: 768px) and (max-width: 960px) {
    max-width: 90%;
    margin: auto;
    display: flex;
    flex-direction: column;
  }

  @media (min-width: 375px) and (max-width: 480px) {
    max-width: 70%;
    margin: auto;
    display: flex;
    flex-direction: column;
  }
`;

const SectionFirst = styled.section``;

const ArticleFirst = styled.article`
  color: #a8a29e;
  text-align: center;
  font-size: 1.2rem;
  border: 1px solid #a8a29e;
  border-radius: 1rem;
  padding: 1rem;

  @media (min-width: 576px) and (max-width: 768px) {
    margin-bottom: 1.5rem;
  }

  @media (min-width: 480px) and (max-width: 576px) {
    font-size: 1rem;
  }
`;

const SectionSecond = styled.section`
  // .picture {
  //   width: 15rem;
  //   height: 10rem;
  //   border: 3px solid #fafafa;
  //   overflow: hidden;
  // }

  @media (max-width: 576px) {
  }

  @media (max-width: 480px) {
  }

  @media (max-width: 375px) {
  }

  @media (min-width: 576px) and (max-width: 768px) {
    max-width: 100%;
    margin: auto;
    /* display: flex;
		flex-direction: column; */
    display: block;
    align-items: center;
  }

  @media (min-width: 480px) and (max-width: 576px) {
    max-width: 80%;
    margin: auto;
  }

  @media (min-width: 375px) and (max-width: 480px) {
    max-width: 80%;
    margin: auto;
  }
`;

const Picture = styled.div`
  width: 15rem;
  height: 10rem;
  // min-width: 15rem;
  // flex-shrink: 0;

  border-radius: 16px;
  overflow: hidden;
  position: relative;

  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.02);

  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);

  transition: all 0.4s ease;

  &::after {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.4), transparent);
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &:hover::after {
    opacity: 1;
  }

  &:hover {
    transform: translateY(-6px) scale(1.02);
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5);
  }
`;

const MotionPicture = motion(Picture);

const BaseArticle = `
  position: relative;
  padding: 1rem;
  border-radius: 20px;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.02);
    backdrop-filter: blur(6px);
  }
`;

const ArticleSecond = styled.article`
  ${BaseArticle};
  margin-bottom: 3rem;
  display: flex;
  align-items: center;
  gap: 2rem;

  @media (max-width: 480px) {
  }

  @media (min-width: 768px) and (max-width: 960px) {
  }

  @media (min-width: 576px) and (max-width: 768px) {
    align-items: center;
    /* display: flex; */
    flex-direction: column;
  }

  @media (min-width: 480px) and (max-width: 576px) {
    margin: 0;
    padding-top: 2rem;
    display: block;
  }

  @media (min-width: 375px) and (max-width: 480px) {
    margin: 0;
    padding-top: 2rem;
    display: block;
  }
`;

const Img = styled.img`
  // width: 100%;
  // height: 100%;
  // object-fit: scale-down;

  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top; /* ← ici */

  transition: transform 0.5s ease;

  ${Picture}:hover & {
    transform: scale(1.08);
  }

  @media (min-width: 768px) and (max-width: 960px) {
    /* width: 20rem; */
  }

  @media (min-width: 576px) and (max-width: 768px) {
    /* width: 20rem; */
  }
`;

const DivText = styled.div`
  //padding-left: 1.5rem;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 5px;
    width: 2px;
    height: 40px;
    background: rgba(180, 1, 18, 0.5);
    border-radius: 2px;
  }

  @media (max-width: 768px) {
    padding-left: 0;
    margin-top: 1rem;

    &::before {
      display: none;
    }
  }
`;

const Title = styled.h2`
  text-transform: uppercase;
  padding-left: 1rem;
`;

const Text = styled.p`
  font-size: 1.1rem;
  line-height: 1.6;
  color: #a8a29e;
  max-width: 400px;

  @media (max-width: 768px) {
    font-size: 0.9rem;
  }
`;

const Category = styled.p`
  color: #a8a29e;
  font-weight: bold;
  font-size: 0.8rem;
  font-style: italic;
  text-transform: uppercase;

  @media (max-width: 768px) {
    font-size: 0.7rem;
  }
`;

const ArticleThird = styled.article`
  ${BaseArticle};
  margin: 0 0 3rem 8rem;
  display: flex;
  align-items: center;
  gap: 2rem;

  @media (min-width: 768px) and (max-width: 960px) {
    margin: 0;
  }

  @media (min-width: 576px) and (max-width: 768px) {
    align-items: center;
    margin: 0;
    /* margin: 0 0 2rem 3rem; */
    padding-top: 2rem;
    flex-direction: column;
  }

  @media (min-width: 480px) and (max-width: 576px) {
    margin: 0;
    padding-top: 2rem;
    display: block;
  }

  @media (min-width: 375px) and (max-width: 480px) {
    margin: 0;
    padding-top: 2rem;
    display: block;
  }
`;

const ArticleFour = styled.article`
  ${BaseArticle};
  margin-left: 16rem;
  display: flex;
  align-items: center;
  gap: 2rem;

  @media (min-width: 768px) and (max-width: 960px) {
    margin: 0;
    padding-top: 3rem;
  }

  @media (min-width: 576px) and (max-width: 768px) {
    align-items: center;

    /* margin-left: 7rem; */
    margin: 0;
    padding-top: 2rem;
    flex-direction: column;
  }

  @media (min-width: 480px) and (max-width: 576px) {
    margin: 0;
    display: block;
    padding-top: 2rem;
  }

  @media (min-width: 375px) and (max-width: 480px) {
    margin: 0;
    padding-top: 2rem;
    display: block;
  }
`;

const ArticleFifth = styled.article`
  ${BaseArticle};
  margin-left: 24rem;
  display: flex;
  align-items: center;
  gap: 2rem;

  @media (min-width: 768px) and (max-width: 960px) {
    margin: 0;
    padding-top: 3rem;
  }

  @media (min-width: 576px) and (max-width: 768px) {
    align-items: center;
    margin: 0;
    padding-top: 2rem;
    flex-direction: column;
  }

  @media (min-width: 480px) and (max-width: 576px) {
    margin: 0;
    display: block;
    padding-top: 2rem;
  }

  @media (min-width: 375px) and (max-width: 480px) {
    margin: 0;
    padding-top: 2rem;
    display: block;
  }
`;
